import { Link, useSearch } from "@tanstack/react-router";
import { Check } from "lucide-react";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { track } from "@/lib/analytics";
import { queryClient, trpc, trpcClient } from "@/lib/trpc";

/** Landing page after a Polar checkout (POLAR_SUCCESS_URL → /success). */
export function SuccessPage() {
	const { checkout_id: checkoutId } = useSearch({ from: "/app/success" });

	useEffect(() => {
		track("billing.checkout_completed", {
			has_checkout_id: Boolean(checkoutId),
		});
		// Pick up the new plan and any top-up credits right away (the webhook
		// may still be on its way), then refresh what shows them.
		trpcClient.billing.refresh
			.mutate()
			.catch(() => {
				/* the webhook will catch up */
			})
			.finally(() => {
				queryClient.invalidateQueries({ queryKey: trpc.getUsage.queryKey() });
				queryClient.invalidateQueries({
					queryKey: trpc.billing.summary.queryKey(),
				});
				queryClient.invalidateQueries({
					queryKey: trpc.billing.history.queryKey(),
				});
			});
	}, [checkoutId]);

	return (
		<div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center gap-4 p-8 text-center">
			<div className="flex size-14 items-center justify-center rounded-full bg-primary text-primary-foreground">
				<Check className="size-7" strokeWidth={2.5} />
			</div>
			<h1 className="font-display font-extrabold text-2xl tracking-[-0.02em]">
				You're all set
			</h1>
			<p className="text-muted-foreground">
				Thanks! Your plan and credits are ready to use.
			</p>
			{checkoutId && (
				<p className="text-muted-foreground text-xs">
					Checkout ID: {checkoutId}
				</p>
			)}
			<div className="mt-4 flex gap-2">
				<Button asChild>
					<Link to="/">Go to library</Link>
				</Button>
				<Button asChild variant="outline">
					<Link to="/account">View plan</Link>
				</Button>
			</div>
		</div>
	);
}
